import { StepProps, StepsProps } from "antd";
import classnames from "classnames";

import FontFa from "../fontFa/fontFa";
import styles from "./Steps.module.scss";
import { useCallback } from "react";
import { DateHelper } from "../../helper";
import { DateFormat, RequestStatus } from "../../constants";

interface StepContent {
  name: string;
  email: string;
  actionText?: string;
  date?: string;
  history?: any[];
}
interface Step extends StepProps {
  stepContent?: StepContent;
}

type StepItem = Step | Step[];
interface Props extends Omit<StepsProps, "items"> {
  items: StepItem[];
}

// const getActionTextByStatus = (status: string) => {
//   if (status === RequestStatus.created) {
//     return "Ngày tạo: ";
//   }
//   if (status === RequestStatus.canceled) {
//     return "Ngày huỷ: ";
//   }
//   if (status === RequestStatus.approved) {
//     return "Ngày duyệt: ";
//   }
//   return "";
// };

function StepDescription(props: any) {
  const { name, email, histories = [] } = props;
  const renderedHistory = histories.map((item: any, index: number) => (
    <div
      key={index}
      style={item.status === RequestStatus.canceled ? { color: "red" } : {}}
    >
      {item.label}: {" "}
      {DateHelper.formatDateToString(item.updatedDateTime, {
        format: DateFormat.DD_MM_YYYY_HH_MM,
      })}
    </div>
  ));
  return (
    <div className={styles.stepDescription}>
      <div>{name}</div>
      <div>{email}</div>
      {renderedHistory}
    </div>
  );
}

export function NPSteps(props: Partial<Props>) {
  const {
    direction = "horizontal",
    size = "default",
    current = 0,
    items = [],
    status = "",
  } = props;

  const classNames = classnames("TimelineBox horizontal", {
    mdHorizontal: direction === "horizontal",
    mdSmall: size === "small",
  });

  const getStep = (currentIndex: number) => {
    const isApproved =
      currentIndex < current ||
      (status === "finish" && currentIndex === current);
    const isRejected = status === "error" && currentIndex === current;
    if (isApproved) {
      return { icon: <FontFa name="faCheck" />, classNameStatus: "approved" };
    }
    if (isRejected) {
      return { icon: <FontFa name="faBan" />, classNameStatus: "rejected" };
    }
    return { icon: null, classNameStatus: "waiting" };
  };

  const renderedContent = useCallback((item: StepItem) => {
    const stepItems = Array.isArray(item) ? item : [item];
    return stepItems.map((step, index) => (
      <div key={index} className={styles.stepContent}>
        {step.title && <div className={styles.title}>{step.title}</div>}
        <StepDescription {...step} />
      </div>
    ));
  }, []);

  return (
    <div className={classNames}>
      {items.map((item, idx) => (
        <div key={idx} className={classnames("item", styles.item)}>
          <div className={classnames("step", getStep(idx).classNameStatus)}>
            {getStep(idx).icon}
          </div>
          <div className={classnames("content", styles.content)}>
            {renderedContent(item)}
          </div>
        </div>
      ))}
    </div>
  );
}
